const setPointRadius = (path, radius) => {
  path.pointRadius([radius]);
};

export { setPointRadius };
